import React from "react";
import { Link } from "react-router-dom";
import { FiInstagram, FiLinkedin, FiMail, FiPhone } from "react-icons/fi";
import { APP_STORE_URL, PLAY_STORE_URL } from "../print/lib/device";
import shops from "../data/shops.json";
import { SITE } from "./siteInfo";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer__top">
          <div className="footer__brand">
            <Link to="/" className="footer__word" aria-label="PrintAnywhere home">
              <b>Print</b>Anywhere
            </Link>
            <p className="footer__tag">{SITE.tagline}</p>
            <p className="footer__blurb">Upload from anywhere, pay online and collect your prints at a partner shop near you. No WhatsApp, no queue, no reconfiguring at the counter.</p>
            <div className="footer__badges">
              <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play">
                <img src="/img/playstore.webp" alt="Get it on Google Play" loading="lazy" width="130" height="40" />
              </a>
              <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store">
                <img src="/img/applestore.webp" alt="Download on the App Store" loading="lazy" width="130" height="40" />
              </a>
            </div>
          </div>
          <div className="footer__col">
            <h4>Print</h4>
            <Link to="/print">Print from your browser</Link>
            <a href="/#how-it-works">How it works</a>
            <a href="/#features">Features</a>
            <Link to="/get-app">Get the app</Link>
            <Link to="/user-guide">User guide</Link>
          </div>
          <div className="footer__col">
            <h4>Shops</h4>
            {shops.cities.map((c) => (
              <Link key={c.slug} to={`/print-shops/${c.slug}`}>
                {c.name}
              </Link>
            ))}
            <Link to="/print-shops">All partner shops</Link>
            <a href="/#partner">Become a partner</a>
          </div>
          <div className="footer__col">
            <h4>Help</h4>
            <Link to="/faq">FAQ</Link>
            <Link to="/contact">Contact us</Link>
            <Link to="/orders">My orders</Link>
            <Link to="/refer">Refer a friend</Link>
            <Link to="/offers">Offers</Link>
            <Link to="/delete-account">Delete account</Link>
          </div>
          <div className="footer__col">
            <h4>Company</h4>
            <Link to="/privacy-policy">Privacy policy</Link>
            <Link to="/terms">Terms and conditions</Link>
            <Link to="/refund-policy">Cancellation and refunds</Link>
            <a className="footer__contact" href={`tel:${SITE.phoneE164}`}>
              <FiPhone /> {SITE.phone}
            </a>
            <a className="footer__contact" href={`mailto:${SITE.supportEmail}`}>
              <FiMail /> {SITE.supportEmail}
            </a>
          </div>
        </div>
        <div className="footer__bottom">
          <span>
            © {new Date().getFullYear()} PrintAnywhere, a product of{" "}
            <a href="https://www.smittechnologies.com/" rel="noopener noreferrer" target="_blank">
              SMIT
            </a>
            , {SITE.address.city}
          </span>
          <span className="footer__social">
            <a href="https://www.linkedin.com/in/vinaylomate/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FiLinkedin />
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FiInstagram />
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
